module.exports = __webpack_public_path__ + "img/lock_quiz.4832cb7b.svg";